import { SignedDocument, SseEvents, SseResultObject } from '../states';
import { createRequestReducer } from './RequestReducer';

export const operationStartedReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_STARTED]>();

export const idCapturedReducer =
  createRequestReducer<SseResultObject[SseEvents.ID_CAPTURED]>();

export const selfieCapturedReducer =
  createRequestReducer<SseResultObject[SseEvents.SELFIE_CAPTURED]>();

export const facialAuthenticationReducer =
  createRequestReducer<
    SseResultObject[SseEvents.FACIAL_AUTHENTICATION_EVALUATED]
  >();

export const passiveLivenessReducer =
  createRequestReducer<SseResultObject[SseEvents.PASSIVE_LIVENESS_EVALUATED]>();

export const idValidatedReducer =
  createRequestReducer<SseResultObject[SseEvents.ID_VALIDATED]>();

export const civilRegistryReducer =
  createRequestReducer<SseResultObject[SseEvents.CIVIL_REGISTRY_VALIDATED]>();

export const previousOnboardingReducer =
  createRequestReducer<
    SseResultObject[SseEvents.PREVIOUS_ONBOARDING_VALIDATED]
  >();

export const facialExtractionReducer =
  createRequestReducer<
    SseResultObject[SseEvents.FACIAL_EXTRACTION_EVALUATED]
  >();

export const operationFinishedReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_FINISHED]>();

export const operationExpiredReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_EXPIRED]>();

export const documentSignatureReducer = createRequestReducer<SignedDocument>();

export const personalInformationReducer =
  createRequestReducer<
    SseResultObject[SseEvents.PERSONAL_INFORMATION_GATHERED]
  >();
